export class PhoneNumberUtils {
    public static comparePhoneNumbers(phoneNumber1: string, phoneNumber2: string): boolean {
      if (!phoneNumber1 || !phoneNumber2) {
          return false;
      }

      const cleaned1 = ('' + phoneNumber1).replace(/\D/g, '');
      const cleaned2 = ('' + phoneNumber2).replace(/\D/g, '');
      return cleaned1 === cleaned2;
    }

    public static removeNonDigitsFromPhoneNumber(phoneNumber: string): string {
      if(phoneNumber) {
        return phoneNumber.replace(/\D/g, '');
      }

      return '';
    }

    public static formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) {
          return '';
      }
      const cleaned = ('' + phoneNumber).replace(/\D/g, '');
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
          return '(' + match[1] + ') ' + match[2] + '-' + match[3];
      }
      return phoneNumber;
    }
}
